import SharedEvaluationNodesPage from 'pages/mobile/Finance/shared/EvaluationNodesPage';
import React from 'react';

const CreditLineEvaluationNodesPage: React.FC = () => (
  <SharedEvaluationNodesPage product="creditLine" />
);

export default CreditLineEvaluationNodesPage;
